/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ShortPositions } from '../models/short-positions';
@Injectable({
  providedIn: 'root',
})
class IssuerPriceService extends __BaseService {
  static readonly getPriceByIssuerManagerAndDatePath = '/issuerPrice/{issuerName}/';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param issuerName Issuer Name
   * @return sdsDataForChart
   */
  getPriceByIssuerManagerAndDateResponse(issuerName: string): __Observable<__StrictHttpResponse<Array<ShortPositions>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/issuerPrice/${encodeURIComponent(String(issuerName))}/`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ShortPositions>>;
      })
    );
  }
  /**
   * @param issuerName Issuer Name
   * @return sdsDataForChart
   */
  getPriceByIssuerManagerAndDate(issuerName: string): __Observable<Array<ShortPositions>> {
    return this.getPriceByIssuerManagerAndDateResponse(issuerName).pipe(
      __map(_r => _r.body as Array<ShortPositions>)
    );
  }
}

module IssuerPriceService {
}

export { IssuerPriceService }
